// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\">\r\n  <path d=\"M452 512H60c-33.086 0-60-26.914-60-60V60C0 26.914 26.914 0 60 0h392c33.086 0 60 26.914 60 60v392c0 33.086-26.914 60-60 60zM60 40c-11.027 0-20 8.973-20 20v392c0 11.027 8.973 20 20 20h392c11.027 0 20-8.973 20-20V60c0-11.027-8.973-20-20-20z\"/>\r\n</svg>\r\n";
// Exports
module.exports = code;